/* eslint-disable */

import { Box, Button } from '@mui/material';

export default function TransactionTabs({ tabIndex, setTabIndex, tabLabels }) {
    return (
        <Box sx={{ mb: 3, display: 'flex', gap: 1, flexWrap: 'wrap' }}>
            {tabLabels.map((label, index) => (
                <Button
                    key={label}
                    variant={tabIndex === index ? 'contained' : 'outlined'}
                    onClick={() => setTabIndex(index)}
                    sx={{
                        color: tabIndex === index ? '#fff' : '#1b0e52',
                        borderColor: '#1b0e52',
                        background: tabIndex === index ? 'linear-gradient(135deg, rgb(25, 26, 27), #1976D2)' : 'transparent',
                        '&:hover': {
                            background: tabIndex === index ? 'linear-gradient(135deg, rgb(25, 26, 27), #1976D2)' : '#f2f2f2'
                        }
                    }}
                >
                    {label}
                </Button>
            ))}
        </Box>
    );
}
